import { render, staticRenderFns } from "./DPL.vue?vue&type=template&id=c436f632"
import script from "./DPL.vue?vue&type=script&lang=js"
export * from "./DPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports